import React from "react";
import "./revenue.css";
import { exportRevenueExcel } from "./exportRevenueExcel";

export default function TopBar({ data }) {
  const onExport = () => exportRevenueExcel(data, "Revenue_Export.xlsx");

  return (
    <div className="rt-topbar mb-2">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <div className="rt-top-title">Revenue Explorer</div>
          <div className="rt-top-sub">Multi-view hierarchical revenue analysis platform</div>
        </div>

        <div className="rt-top-actions">
          <button className="rt-export-btn" onClick={onExport}>
            Export{" "}
            <img
              src="/img/export_arrow.png"
              alt="export"
              className="cardinal_filter_img"
            />
          </button>
        </div>
      </div>
    </div>
  );
}
